import AddIcon from "components/icons-svg/AddIcon";
import MinusIcon from "components/icons-svg/MinusIcon";
function Counter({
  value,
  decrementCounter,
  incrementCounter,
  max = 10,
  isDetailPage,
  isIncrementDisabled = false
}: {
  decrementCounter: () => void;
  incrementCounter: () => void;
  isDetailPage?: boolean;
  max?: number;
  value: string | number;
  isIncrementDisabled?: boolean;
}) {
  // For increment and decrement Pass function to change value in store or where ever you want.
  return <div className='flex items-center justify-between' data-sentry-component="Counter" data-sentry-source-file="Counter.tsx">
      <div className='flex items-center space-x-2.5'>
        <button type='button' className='btn btn-secondary h-[30px] w-[30px] min-w-[auto] border-accent-500 p-2' disabled={!isDetailPage ? +value < 1 : +value <= 1} aria-label='decrement' data-testid='dec' onClick={decrementCounter}>
          <MinusIcon className='h-3 w-3 text-inherit' data-sentry-element="MinusIcon" data-sentry-source-file="Counter.tsx" />
        </button>
        <p className='min-w-[1.25rem] text-center font-semibold' data-test={`${value}value`}>
          {value}
        </p>
        <button type='button' className='btn btn-secondary h-[30px]  w-[30px] min-w-[auto] border-accent-500 p-1.5' aria-label='increment' data-testid='inc' data-test={value} onClick={incrementCounter} disabled={+value >= max || isIncrementDisabled}>
          <AddIcon className='h-4 w-4 text-inherit ' data-sentry-element="AddIcon" data-sentry-source-file="Counter.tsx" />
        </button>
      </div>
    </div>;
}
export default Counter;